import {TabState, TabStateDefaults} from 'Navigation';

export default class BulkAssemblyFragmentsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Fragments',
      closeable: false,
      preferenceKey: 'bulk_assembly_fragments',
    };
  }
}
